export default (params) => ({
  trigger: {
    name: 'assortment_entrance_navigation.assortment_navigation',
    params: params,
  },
  config: {
    schema: {
      content: {
        enum: [
          'open_assortment',
          'close_assortment',
        ],
      },
      sub_feature: {
        enum: [
          'header',
          'search',
        ],
      },
    },
    event: {
      name: 'select_all',
    },
  },
});
